import { EnumScreenName, EnumResourceTab } from '@calm/evexia-analytics';
import {
    CircleReferralButtonTypeEnum,
    CirclePartnerHealthResource,
} from '@calm/evexia-web-sdk';
import { ActionDataProps } from '@rhg/components/action-dialog/types';

export function formatDataForActionSheet(
    resource: CirclePartnerHealthResource,
    source?: EnumScreenName,
    sponsor?: string,
    selectedTab?: EnumResourceTab
): ActionDataProps | undefined {
    if (resource) {
        const {
            id,
            resourceId,
            logoUrl,
            name,
            category,
            theme,
            actionSheetDescription,
            additionalCopy,
            linkOut1AdditionalCopy,
            linkOut2AdditionalCopy,
            linkOut1Header,
            linkOut2Header,
            linkOut1Description,
            linkOut2Description,
            linkOut1Text,
            linkOut1Type,
            linkOut1Data,
            linkOut2Text,
            linkOut2Type,
            linkOut2Data,
            linkOut1IsEnabled,
            linkOut2IsEnabled,
            linkOutMobileIsEnabled,
            linkOutIosStore,
            linkOutAndroidStore,
        } = resource;
        const buttons = [];

        // If actionSheetDescription is set, display simple view. Otherwise display detailed view.
        if (actionSheetDescription) {
            if (linkOut1IsEnabled) {
                buttons.push({
                    title: linkOut1Text || '',
                    type: linkOut1Type as CircleReferralButtonTypeEnum,
                    data: linkOut1Data || '',
                });
            }
            if (linkOut2IsEnabled) {
                buttons.push({
                    title: linkOut2Text || '',
                    type: linkOut2Type as CircleReferralButtonTypeEnum,
                    data: linkOut2Data || '',
                });
            }
            return {
                id,
                resourceId,
                trackScreen: source,
                trackDialog: 'ResourceSheetDialog',
                trackButton: 'ResourceLink',
                selectedTab,
                logoUrl,
                logoName: name,
                title: name,
                sponsor: sponsor,
                category,
                theme,
                hasMobileLinks: linkOutMobileIsEnabled,
                iosLink: linkOutIosStore,
                androidLink: linkOutAndroidStore,
                description: actionSheetDescription,
                additionalCopy: additionalCopy,
                buttons,
            };
        } else {
            if (linkOut1IsEnabled) {
                buttons.push({
                    header: linkOut1Header || '',
                    description: linkOut1Description || '',
                    additionalCopy: linkOut1AdditionalCopy,
                    title: linkOut1Text || '',
                    type: linkOut1Type as CircleReferralButtonTypeEnum,
                    data: linkOut1Data || '',
                });
            }
            if (linkOut2IsEnabled) {
                buttons.push({
                    header: linkOut2Header || '',
                    description: linkOut2Description || '',
                    additionalCopy: linkOut2AdditionalCopy,
                    title: linkOut2Text || '',
                    type: linkOut2Type as CircleReferralButtonTypeEnum,
                    data: linkOut2Data || '',
                });
            }
            return {
                id,
                resourceId,
                trackScreen: source,
                trackDialog: 'ResourceSheetDialog',
                trackButton: 'ResourceLink',
                selectedTab,
                logoUrl,
                logoName: name,
                title: name,
                sponsor: sponsor,
                category,
                theme,
                hasMobileLinks: linkOutMobileIsEnabled,
                iosLink: linkOutIosStore,
                androidLink: linkOutAndroidStore,
                buttons,
            };
        }
    }
}
